var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hasUser)?_c('EmployeeBadgeScanner',{ref:"rfid",attrs:{"label":"แสกนบัตรพนักงาน"},on:{"setUser":_vm.setUser}}):_c('PinInput',{attrs:{"user":_vm.user},on:{"onPinInput":_vm.onPinInput,"onError":_vm.onError}})}
var staticRenderFns = []

export { render, staticRenderFns }